import React, { useEffect, useState } from 'react';

// Live scoring config table for the public Methodology page (same table the server scores with).
export const MethodologyWeights = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/research/config`).then((r) => r.json()).then(setCfg).catch(() => setCfg(false));
  }, []);
  if (cfg === false) return <p>The scoring table could not be loaded right now.</p>;
  if (!cfg) return null;
  const factors = [...new Set(Object.values(cfg.strategies).flatMap((s) => Object.keys(s.weights)))];
  return (
    <section data-testid="methodology-weights">
      <h2>AI Search factor weights (config {cfg.version})</h2>
      <p>Each strategy scores the same factors with its own weights, which always sum to 100%. If a factor has insufficient data, it is excluded and the remaining weights are re-normalized; nothing is filled with a placeholder value.</p>
      <div style={{ overflowX: 'auto' }}><table className="mw-table">
        <thead><tr><th>Factor</th>{Object.values(cfg.strategies).map((s) => <th key={s.label}>{s.label}</th>)}</tr></thead>
        <tbody>{factors.map((f) => <tr key={f}><td>{f}</td>{Object.entries(cfg.strategies).map(([k, s]) => <td key={k}>{s.weights[f] ? `${s.weights[f]}%` : '—'}</td>)}</tr>)}</tbody>
      </table></div>
      <h2>Risk profiles</h2>
      <div style={{ overflowX: 'auto' }}><table className="mw-table">
        <thead><tr><th>Profile</th><th>Stop (× ATR)</th><th>Account risk per trade</th><th>Score needed for a verdict</th><th>Minimum confidence</th></tr></thead>
        <tbody>{Object.values(cfg.risk_profiles).map((r) => <tr key={r.label}><td>{r.label}</td><td>{r.stop_atr}</td><td>{r.account_risk_pct}%</td><td>≥ {r.score_edge} or ≤ {100 - r.score_edge}</td><td>{r.min_confidence}</td></tr>)}</tbody>
      </table></div>
      <p>Scores between {cfg.neutral_score[0]} and {cfg.neutral_score[1]} are neutral. Probabilities are model estimates, shown between {cfg.prob_clamp[0] * 100}% and {cfg.prob_clamp[1] * 100}%, and a Bullish or Bearish label also requires the probability, options flow and key-level order to agree. Accuracy is shown once at least {cfg.calibration_min} past outlooks for a strategy and horizon have been graded.</p>
    </section>
  );
};
